export default __webpack_public_path__ + "static/media/linkedin.558266d0.svg";